<template>
  <div>
    <v-container class="app-breadcrumbs-container">
      <v-breadcrumbs class="app-breadcrumbs" :items="breadcrumbs">
        <v-icon slot="divider">chevron_right</v-icon>
        <template slot="item" slot-scope="props">
          <router-link
            :to="props.item.to"
            :class="[
              props.item.disabled && 'v-breadcrumbs__item--disabled',
              'app-breadcrumbs__item'
            ]"
          >
            {{ props.item.text }}
          </router-link>
        </template>
      </v-breadcrumbs>
    </v-container>
    <div class="main-title">
      <v-container fill-height>
        <v-layout align-center>
          {{ $t("address.title") }}
        </v-layout>
      </v-container>
    </div>
    <v-container>
      <div>
        <GmapMap
          style="width: 100%; height: 350px;"
          :zoom="14"
          :center="center"
        >
          <GmapMarker
            v-for="(marker, index) in markers"
            :key="index"
            :position="marker.position"
          />
          <GmapMarker
            label="★"
            :position="center"
            :clickable="true"
            :draggable="true"
            @dragend="handleDrag"
          />
        </GmapMap>
      </div>
    </v-container>
    <v-container class="lost-container">
      <v-form ref="form">
        <v-container>
          <v-layout>
            <v-flex xs12>
              <v-text-field
                v-model="contact"
                ref="contact"
                :rules="nameRules"
                validate-on-blur
                :label="$t('address.name')"
                required
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-text-field
                v-model="phone"
                ref="phone"
                :rules="phoneRules"
                validate-on-blur
                :label="$t('address.phone')"
                required
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-text-field
                v-model="address1"
                ref="address1"
                :rules="nameRules"
                validate-on-blur
                :label="$t('address.address1')"
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-text-field
                v-model="city"
                ref="city"
                :rules="nameRules"
                validate-on-blur
                :label="$t('address_create.city')"
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-text-field
                v-model="zipcode"
                ref="city"
                :rules="nameRules"
                validate-on-blur
                :label="$t('address.zipcode')"
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4>
              <v-switch
                v-model="defaultAddress"
                :label="$t('address_create.default')"
              ></v-switch>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-layout justify-start>
        <v-flex shrink mr-4>
          <button class="button shadow" @click="updateAddress">
            {{ $t("address.btn") }}
          </button>
        </v-flex>
        <v-flex shrink>
          <button class="button-dark shadow" @click="handleDelete">
            {{ $t("address.delete") }}
          </button>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("address.tip_title") }}</span>
        </v-card-title>
        <v-card-text>
          <small>{{ $t("address.confrim_delete") }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">
            {{ $t("address.cancel") }}
          </v-btn>
          <v-btn color="blue darken-1" flat @click="confrimDelete">{{
            $t("address.confrim")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showTip" max-width="500px">
      <v-card>
        <v-card-title>
          <span>{{ tip }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn color="primary" flat @click="showTip = false">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import address from "@/api/address";
import axios from "axios";
import { mapMutations, mapState } from "vuex";
const instance = axios.create();

export default {
  data() {
    return {
      nameRules: [value => !!value || this.$t("login.rules")],
      phoneRules: [
        value => !!value || this.$t("login.rules"),
        value => /^[679]\d{8}$/.test(value) || this.$t("common.phone_rule")
      ],
      dialog: false,
      guid: "",
      contact: "",
      phone: "",
      zipcode: "",
      address1: "",
      city: "",
      defaultAddress: true,
      showTip: false,
      tip: "",
      markers: [],
      place: null,
      center: { lat: 40.37816496854541, lng: -3.6536622047424316 }
    };
  },
  created() {
    this.guid = this.$route.params.guid;
    this.loadAddressDetail();
  },
  computed: {
    ...mapState(["isLogin"]),
    breadcrumbs() {
      return [
        {
          to: { name: "account/info" },
          disabled: false,
          text: this.$t("breadcrumbs.account")
        },
        {
          to: { name: "address" },
          disabled: false,
          text: this.$t("breadcrumbs.address_list")
        },
        {
          to: { name: "order/list" },
          disabled: true,
          text: this.$t("breadcrumbs.address_edit")
        }
      ];
    },
    form() {
      return {
        contact: this.contact,
        phone: this.phone,
        city: this.city,
        zipcode: this.zipcode,
        address1: this.address1
      };
    }
  },
  methods: {
    ...mapMutations(["setZipCode"]),
    submit() {
      this.$router.push({ name: "address" });
    },
    handleDelete() {
      this.dialog = true;
    },
    confrimDelete() {
      this.dialog = false;
      this.deleteAddress();
    },
    async loadAddressDetail() {
      try {
        const res = await address.loadAddressDetail({ guid: this.guid });
        if (!res.data.isError) {
          this.contact = res.data.data.contact;
          this.phone = res.data.data.phone;
          this.city = res.data.data.city;
          this.defaultAddress = res.data.data.defaultAddress;
          this.address1 = res.data.data.address1;
          this.center.lat = parseFloat(res.data.data.latitude);
          this.center.lng = parseFloat(res.data.data.longitude);
          this.zipcode = res.data.data.zipcode;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async updateAddress() {
      console.log("是否为默认", this.defaultAddress);
      try {
        const res = await address.updateAddress({
          ...this.form,
          guid: this.guid,
          latitude: this.center.lat,
          longitude: this.center.lng,
          defaultAddress: this.defaultAddress
        });
        if (this.isLogin == false) {
          let adress = JSON.stringify(res.data.data);
          localStorage.setItem("addressList", adress);
          this.setZipCode(this.zipcode);
        }

        if (res.data.isError) {
          this.tip = res.data.msg;
          this.showTip = true;
          return;
        }

        if (this.$route.query.editSuccessRedirectType === "back") {
          this.$router.back();
        }

        this.$router.push({ name: "address" });
      } catch (e) {
        this.tip = e.response.data.msg;
        this.showTip = true;
      }
    },

    async deleteAddress() {
      try {
        const res = await address.deleteAddress({ guid: this.guid });

        if (res.data.isError) {
          this.tip = res.data.msg;
          this.showTip = true;
          return;
        }

        if (this.$route.query.editSuccessRedirectType === "back") {
          this.$router.back();
        }

        this.$router.push({ name: "address" });
      } catch (e) {
        this.tip = e.response.data.msg;
        this.showTip = true;
      }
    },

    handleDrag(position) {
      this.loadDetail(position.latLng.lat(), position.latLng.lng());
      this.center = {
        lat: position.latLng.lat(),
        lng: position.latLng.lng()
      };
    },

    async loadDetail(lat, lng) {
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBHHR5duzSnYc-gP8ZT5TbJr5Yf2SkVGUQ&language=es`;
      instance
        .get(url, {
          "access-control-request-headers": "Content-Type"
        })
        .then(response => {
          if (response.data.status === "OK") {
            const { results } = response.data;

            if (results.length === 0) {
              return;
            }

            const address = results[0].address_components || [];

            this.address1 = this.getAddressName(address, ["route"]);

            this.city = this.getAddressName(address, [
              "locality",
              "administrative_area_level_2"
            ]);
            this.zipcode = this.getAddressName(address, ["postal_code"]);
          } else {
            console.log("error");
          }
        });
    },

    getAddressName(address, type) {
      const result = address.find(item => {
        return (
          item.types.findIndex(typeName => {
            return type.includes(typeName);
          }) > -1
        );
      });

      return result ? result.long_name : "";
    }
  }
};
</script>

<style scoped lang="sass" src="./edit.sass"></style>
